// extracted by mini-css-extract-plugin
export default {"shows":"Shows_shows__0XmVb","showsHeader":"Shows_showsHeader__FlzWh","text":"Shows_text__COT0t"};